<template>
  <div id="wrapper" class="toppage">
    <app-header></app-header>
    <sidenav></sidenav>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from "@/components/app/header.vue";
import AppFooter from "@/components/app/footer.vue";
import Sidenav from "@/components/app/sidenav.vue";

import MenuService from "@/services/MenuService.js";

export default {
  components: {
    AppHeader,
    AppFooter,
    Sidenav
  },

  created() {
    this.getTopMenus();
  },

  methods: {
    getTopMenus() {
      MenuService.getTopMenu().then(response => {
        this.$store.dispatch("setTopmenus", response.data.payload);
      });
    }
  }
};
</script>
